import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { User } from "src/app/core/models/user";
import { UserRoleNames } from "src/app/core/models/users";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { UserService } from "src/app/core/services/user.service";

@Component({
  selector: "app-saml-login",
  templateUrl: "./saml-login.component.html",
  styleUrls: ["./saml-login.component.scss"],
})
export class SamlLoginComponent implements OnInit {
  paramFirstName = "";
  paramLastName = "";
  paramToken = "";
  paramUserName = "";
  isClientLogin = this.router.url.includes("Client");
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    public userService: UserService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params["token"]) {
        this.paramFirstName = params["firstName"];
        this.paramLastName = params["lastName"];
        this.paramToken = params["token"];
        this.paramUserName = params["userName"];
      } else {
        this.router.navigate(["/Login"]);
      }

      let userObj: User = {
        id: 1,
        username: this.paramUserName,
        password: "",
        firstName: this.paramFirstName,
        lastName: this.paramLastName,
        role: UserRoleNames.JobOperator,
        token: this.paramToken,
      };
      let role = "";
      this.userService.getUserRole(this.paramUserName).subscribe({
        next: (data) => {
          let roleNum = Number(data);
          switch (roleNum) {
            case 0:
              role = UserRoleNames.GlobalAdmin;
              break;

            case 1:
              role = UserRoleNames.DeploymentAdmin;
              break;

            case 2:
              role = UserRoleNames.PowerUser;
              break;

            case 3:
              role = UserRoleNames.JobOperator;
              break;

            case 4:
              role = UserRoleNames.Reader;
              break;

            default:
              role = "";
              break;
          }

          userObj.role = role;
        },
        error: (err) => { },
      });
      localStorage.setItem("currentUser", JSON.stringify(userObj));
      this.authenticationService.updateCurrentUserValue(userObj);
      if (this.isClientLogin) {
        this.router.navigate(["Client Sessions"]);
      } else {
        this.router.navigate(["/Job List"]);
      }
    });
  }
}
